import React from 'react';
import { Router, Route, Switch } from 'dva/router';
import { LocaleProvider } from 'antd';
import ja_JP from 'antd/lib/locale-provider/ja_JP';

import PaymentPage from '../components/PaymentPage';

function RouterConfig(props) {
  return (
    <LocaleProvider locale={ja_JP}>
    <Router history={props.history}>
      <Switch>
        <Route path="/api/payments" render={() => <PaymentPage appKey={props.app.appkey} />} />
        <Route path="/payment2" render={() => <PaymentPage appKey={props.app.appkey} />} />
      </Switch>
    </Router>
    </LocaleProvider>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/payment/config/router.js